module.exports = __webpack_public_path__ + "img/calendar.76df467c.svg";